export default "__VITE_ASSET__f7ef12f9__"